import React from 'react'
import {SeNice} from "../components/lineamientos/SeNice";

export const SeNicePage = () => {
    return (
        <>
          <SeNice/>
        </>
    )
}
